import React from 'react'
import "../../styles/commonStyles/calqueLoader.css"
import calqueLogo from "../../assets/images/calque_prototype.png"

const CalqueLoader = () => {
  return (
    <div className='calque-loader-container'>
        <div className='calque-loader-image'>
            <img src={calqueLogo} alt="Calque Logo"/>
        </div>
        <div className="dot-loader flex">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
        </div>
    </div>
  )
}

export default CalqueLoader